/* global HeaderDropdown */
const $ = window.jQuery;

/* eslint-disable */

class AccessibleNav {
  constructor(item) {
    this.item = item;
    this.trigger = item.querySelector(':scope > .js-nav-trigger');
    this.panel = item.querySelector(':scope > .js-nav-panel');
    this.anchors = Array.from(item.querySelectorAll('.js-nav-anchor'));

    if (!this.trigger) return;

    this.init();
  }

  init() {
    if (this.trigger.tagName === 'SPAN') {
      this.trigger.setAttribute('tabindex', '0');
      this.trigger.setAttribute('role', 'button');
    }

    if (this.panel) {
      this.trigger.setAttribute('aria-haspopup', 'true');
      this.trigger.setAttribute('aria-expanded', 'false');
    }

    this.item.addEventListener('keydown', e => this.onKeyDown(e));
    this.item.addEventListener('focusout', () => this.onFocusOut());
    this.trigger.addEventListener('focus', () => this.onTriggerFocus());
  }

  open() {
    AccessibleNav.closeAllExcept(this.item);
    this.item.classList.add('is-open');
    if (this.panel) this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.item.classList.remove('is-open');
    if (this.panel) this.trigger.setAttribute('aria-expanded', 'false');
  }

  toggle() {
    if (this.item.classList.contains('is-open')) {
      this.close();
    } else {
      this.open();
    }
  }

  onKeyDown(e) {
    const isTrigger = e.target === this.trigger;

    switch (e.key) {
      case 'Enter':
      case ' ':
        if (isTrigger && this.trigger.tagName === 'SPAN') {
          e.preventDefault();
          this.toggle();
        } else if (isTrigger && this.panel && !this.item.classList.contains('is-open')) {
          e.preventDefault();
          this.open();
        }
        break;

      case 'Escape':
        if (this.item.classList.contains('is-open') || this.item.contains(document.activeElement)) {
          e.preventDefault();
          this.close();
          this.trigger.focus();
        }
        break;

      case 'Tab': {
        if (!this.panel) break;
        const visibleAnchors = this.anchors.filter(a => a.offsetParent !== null);
        if (!visibleAnchors.length) break;

        if (isTrigger && !e.shiftKey) {
          e.preventDefault();
          this.open();
          visibleAnchors[0].focus();
        } else if (isTrigger && e.shiftKey) {
          e.preventDefault();
          this.open();
          visibleAnchors[visibleAnchors.length - 1].focus();
        } else if (e.target === visibleAnchors[0] && e.shiftKey) {
          e.preventDefault();
          this.close();
          const prev = AccessibleNav.getPrevFocusable(this.item);
          if (prev) prev.focus();
        } else if (e.target === visibleAnchors[visibleAnchors.length - 1] && !e.shiftKey) {
          e.preventDefault();
          this.close();
          const next = AccessibleNav.getNextFocusable(this.trigger);
          if (next) next.focus();
        }
        break;
      }

      case 'ArrowDown':
        if (!this.panel) break;
        e.preventDefault();
        if (isTrigger) {
          this.open();
          const first = this.anchors.find(a => a.offsetParent !== null);
          if (first) first.focus();
        } else {
          const idx = this.anchors.indexOf(e.target);
          const next = this.anchors[idx + 1];
          if (next) next.focus();
        }
        break;

      case 'ArrowUp': {
        if (!this.panel) break;
        e.preventDefault();
        const idx = this.anchors.indexOf(e.target);
        if (idx <= 0) {
          this.trigger.focus();
        } else {
          this.anchors[idx - 1].focus();
        }
        break;
      }

      default:
        break;
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.item.contains(document.activeElement)) {
        this.close();
      }
    }, 0);
  }

  onTriggerFocus() {
    if (this.panel) this.open();
  }

  static closeAllExcept(current) {
    AccessibleNav.instances.forEach(nav => {
      if (nav.item !== current) nav.close();
    });
  }

  static getNextFocusable(fromEl) {
    const selector = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const all = Array.from(document.querySelectorAll(selector)).filter(
      el => !el.disabled && el.offsetParent !== null,
    );
    const idx = all.indexOf(fromEl);
    if (idx === -1) return null;
    for (let i = idx + 1; i < all.length; i += 1) {
      if (!fromEl.parentElement || !fromEl.parentElement.contains(all[i])) return all[i];
    }
    return null;
  }

  static getPrevFocusable(skipContainer) {
    const selector = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const all = Array.from(document.querySelectorAll(selector)).filter(
      el => !el.disabled && el.offsetParent !== null && !skipContainer.contains(el),
    );
    const allNodes = Array.from(document.querySelectorAll('*'));
    const itemIndex = allNodes.indexOf(skipContainer);
    for (let i = all.length - 1; i >= 0; i -= 1) {
      if (allNodes.indexOf(all[i]) < itemIndex) return all[i];
    }
    return null;
  }
}

AccessibleNav.instances = [];

function initAccessibleDesktopNav() {
  const items = document.querySelectorAll('.js-nav-list > .js-nav-item');
  AccessibleNav.instances = Array.from(items).map(item => new AccessibleNav(item));

  document.addEventListener('click', e => {
    if (!e.target.closest('.js-nav-item')) {
      AccessibleNav.closeAllExcept(null);
    }
  });
}

$(document).ready(() => {
  // eslint-disable-next-line
  new HeaderDropdown($('.header-dropdown').get(0));

  initAccessibleDesktopNav();
});



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/navigation.js